// extracted by mini-css-extract-plugin
module.exports = {"root":"MobileCarousel_root__2ou6y"};